import { useCompanyInfo } from "./useCompanyInfo";

export const usePayrollCountry = () => {
  const companyInfo = useCompanyInfo();

  // Read the ISO code stored directly on the company record (set in CompanyConfiguration)
  const countryCode = companyInfo?.company?.country_code || "TN";

  return {
    countryCode,
    loading: companyInfo?.loading,
    error: companyInfo?.error,
  };
};
